import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-section avatar-section card"
}
const _hoisted_2 = { class: "row g-0 d-flex align-items-center justify-content-start" }
const _hoisted_3 = { class: "author-section pe-4 mb-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col-md-auto" }
const _hoisted_6 = { class: "card-body p-0" }
const _hoisted_7 = { class: "title card-created-on mb-1" }
const _hoisted_8 = { class: "title card-name" }
const _hoisted_9 = { class: "profession" }

import { computed } from 'vue';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { PHOTO_VIEW_TYPE } from '@/types/enums';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';
import { createdDate } from '@/helpers/utils';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const driveStore = useDriveStore();

const photoUrl = computed(() => {
  if (driveStore.currentCase.owner.photo?.url) {
    return lowResUrlByViewTypeByUrl(driveStore.currentCase.owner.photo.url, PHOTO_VIEW_TYPE.WHSML);
  }
  // eslint-disable-next-line global-require
  return require('@/assets/img/mockup/profile.svg');
});

const fullName = computed(() => `${driveStore.currentCase.owner.firstName} ${driveStore.currentCase.owner.lastName}`);


return (_ctx: any,_cache: any) => {
  return (_unref(driveStore).currentCase.owner.firstName)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _unref(photoUrl),
              class: "img-fluid rounded-circle circle-img",
              alt: "",
              height: "88",
              width: "88"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", _hoisted_7, "Created on: " + _toDisplayString(_unref(createdDate)(_unref(driveStore).currentCase.created, 'DD MMM, YYYY')) + " by:", 1),
              _createElementVNode("h3", _hoisted_8, _toDisplayString(_unref(fullName)), 1),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(driveStore).currentCase?.profile?.speciality?.label), 1)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})